/* eslint-disable camelcase */
import React, { useEffect, useMemo } from "react";
import getConfig from "next/config";
import { useAppState } from "hooks/AppContext";
import { isMobile } from "utils/browser";
import { getJobTrackingProps } from "utils/tracking";
import { JobApplyButtonSideBarModule } from "./JobApplyButtonSideBarModule";
import { SimilarJobsSidebar } from "./SimilarJobsSidebar";
import { SuggestedSearchesSidebarModule } from "./SuggestedSearchesSidebarModule";
import { AdditionalJobLinkList } from "./AdditionalJobLinkList";
import { getActiveVariant, useExperimentState } from "@themuse/experiment-client";
import { getApplyButtonText } from "utils/ApplyButtonTextExperiment";
import styles from "./JobIndividualSidebar.module.scss";

interface JobIndividualSidebarProps {
    setIsOpen?: (x: boolean) => void;
}

export const JobIndividualSidebar = (props: JobIndividualSidebarProps) => {
    const { setIsOpen } = props;
    const [buttonPlacement, setButtonPlacement] = React.useState("right_rail");
    const { job, company } = useAppState();
    const { state, ats_info = { directApplyService: ""} } = job;
    const { directApplyService } = ats_info;
    const { publicRuntimeConfig: { museWebHost } } = getConfig();
    const jobTrackingProps = getJobTrackingProps(job, company);
    const { experiments } = useExperimentState();
    const buttonText = useMemo(() => {
        return getApplyButtonText(state, directApplyService, experiments, getActiveVariant);
    }, [state, directApplyService, experiments]);

    const liveTargetSection: string = directApplyService ? "direct_apply_form" : "off_site";
    const targetSection = state === "live" ? liveTargetSection : "search";
    const isLive = state === "live";

    const trackingObj = {
        ...jobTrackingProps,
        sp_click_button_text: buttonText,
        sp_click_target_page_section: targetSection,
        sp_click_position: buttonPlacement,
        target_page_section: "direct_apply_form",
        sp_click_button_type: isLive ? "apply" : "job_search"
    }

    useEffect(() => {
        if (isMobile()) {
            setButtonPlacement("bottom");
        }
    }, []);

    return (
        <>
            <aside className={styles.jobSidebarContainer}>
                <JobApplyButtonSideBarModule
                    jobState={job.state}
                    jobId={job.id}
                    trackJobApplyProps={trackingObj}
                    setIsOpen={setIsOpen}
                    isDirectApply={!!directApplyService}
                />
                <div className={styles.sidebarModules}>
                    <SimilarJobsSidebar />
                    <SuggestedSearchesSidebarModule
                        job={job}
                        company={company}
                        museWebHost={museWebHost}
                    />
                </div>
            </aside>
            <AdditionalJobLinkList />
        </>
    );
};
JobIndividualSidebar.displayName = "JobIndividualSidebar";
